<template>
<div class="chapter">
<div class="inner_page">
<p class="hd1"><b>ACKNOWLEDGMENTS</b></p>
<p class="noindent">Special thanks to the following for their contributions of materials: Dritz, Gerald and Two Hands Paperie, Golden Acrylic Paints, and Luz De Luna. Enormous thanks to Linda Leibovich, Purna Hegde, and Sasha Schlesinger for contributing their talents and feedback. Thanks to my family for the encouragement—Alex and Marcia Eisner, Jason Reinin, and Sasha and Noah Schlesinger.</p>
<p class="noindentt">Thanks to all the staff at C&amp;T Publishing, including Zinnia Heinzmann; my special editors Roxane Cerda, Liz Aneloski, and Kathryn Patterson; and photographers Rachel Holmes, Diane Pedersen, Kelly Burgoyne, and Estefany Gonzalez.</p>
<p class="fig"><img alt="" src="images/pg6_2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_acknowledgement.vue?16bc02b4